import { AlertTriangle, CheckCircle2, FileText, Loader2 } from "lucide-react";
import { fmtSize } from "@/lib/appsApi";

const byPath = (a, b) => (a.includes("/") - b.includes("/")) || a.localeCompare(b, undefined, { sensitivity: "base", numeric: true });

const RequiredCheck = ({ missing, ruleCount }) => {
  if (!ruleCount) return null;
  if (!missing.length) {
    return <p className="mt-2 flex items-center gap-2 text-xs font-medium text-emerald-700" data-testid="apps-bundle-required-ok"><CheckCircle2 className="h-4 w-4" />All {ruleCount} checklist items found</p>;
  }
  return (
    <div className="mt-2 rounded-xl border border-sky-200 bg-white p-3 text-xs text-slate-700" role="status" data-testid="apps-bundle-required-missing">
      <p className="flex items-center gap-2 font-semibold text-ink"><AlertTriangle className="h-4 w-4 shrink-0 text-amber-600" />Guide only: {missing.length} of {ruleCount} checklist item{ruleCount === 1 ? "" : "s"} not in this bundle. You can still save without them.</p>
      <ul className="mt-2 max-h-40 space-y-0.5 overflow-y-auto pl-6 font-mono">{[...missing].sort(byPath).map((m) => <li key={m} className="break-all" data-testid="apps-bundle-missing-item">{m}</li>)}</ul>
    </div>
  );
};

export const BundleContents = ({ entries, loading, missing = [], ruleCount = 0 }) => {
  if (loading) {
    return <p className="mt-3 flex items-center gap-2 rounded-2xl bg-[#F4F9FD] p-4 text-xs text-slate-600" data-testid="apps-bundle-contents-loading"><Loader2 className="h-4 w-4 animate-spin" />Reading bundle contents…</p>;
  }
  if (!entries) return null;
  const total = entries.reduce((s, e) => s + (e.size || 0), 0);
  return (
    <div className="mt-3 rounded-2xl bg-[#F4F9FD] p-4" data-testid="apps-bundle-contents">
      <p className="font-mono text-[11px] uppercase tracking-[0.15em] text-slate-500" data-testid="apps-bundle-contents-summary">
        Contents · {entries.length} file{entries.length === 1 ? "" : "s"} · {fmtSize(total)} unpacked
      </p>
      <RequiredCheck missing={missing} ruleCount={ruleCount} />
      {entries.length === 0 ? (
        <p className="mt-2 text-xs font-medium text-amber-800" data-testid="apps-bundle-contents-empty">This bundle has no files in it.</p>
      ) : (
        <ul className="mt-2 max-h-64 space-y-1 overflow-y-auto pr-1" data-testid="apps-bundle-contents-list">
          {[...entries].sort((a, b) => byPath(a.path, b.path)).map((e) => (
            <li key={e.path} className="flex items-start gap-2 text-xs" data-testid="apps-bundle-entry">
              <FileText className="mt-0.5 h-3.5 w-3.5 shrink-0 text-sky-600" />
              <span className="min-w-0 flex-1 break-all font-mono text-ink">{e.path}</span>
              {e.size != null && <span className="shrink-0 text-slate-500">{fmtSize(e.size)}</span>}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
